import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

import { SideNavItem } from "./side-nav-item";
import { useSidebar } from "src/contexts/SidebarContext";

const renderItems = ({ depth = 0, items, pathname, updatetitle, isMinimized  }) =>
  // console.log("render ityem check", updateTitle);
  items.reduce(
    (acc, item) =>
      reduceChildRoutes({
        acc,
        depth,
        item,
        pathname,
        updatetitle,
        isMinimized 
      }),
    []
  );

const reduceChildRoutes = ({ acc, depth, item, pathname, updatetitle, isMinimized  }) => {
  const checkPath = !!(item.path && pathname);
  const partialMatch = checkPath ? pathname.includes(item.path) : false;
  const exactMatch = checkPath ? pathname === item.path : false;
  console.log("reduceChild", updatetitle);
  console.log("item item team", item.items);
  if (item.items) {
    console.log("if case entered ");
    acc.push(
      <SideNavItem
        active={partialMatch}
        depth={depth}
        disabled={item.disabled}
        icon={item.icon}
        key={item.title}
        label={item.label}
        open={partialMatch}
        title={item.title}
        updatetitle={updatetitle}
        isMinimized={isMinimized}
      >
        <Stack
          component="ul"
          spacing={0.5}
          sx={{
            listStyle: "none",
            m: 0,
            p: 0,
          }}
        >
          {renderItems({
            depth: depth + 1,
            items: item.items,
            pathname,
            updatetitle,
            isMinimized
          })}
        </Stack>
      </SideNavItem>
    );
  } else {
    console.log("else case entered ");
    acc.push(
      <SideNavItem
        active={exactMatch}
        depth={depth}
        disabled={item.disabled}
        external={item.external}
        icon={item.icon}
        key={item.title}
        label={item.label}
        path={item.path}
        title={item.title}
        updatetitle={updatetitle}
        isMinimized={isMinimized}
      />
    );
  }
  console.log("acc", acc);

  return acc;
};

export const SideNavSection = (props) => {
  const { items = [], pathname, subheader = "", updatetitle, ...other } = props;
  const { isMinimized } = useSidebar();
  console.log("side nav section", items);
  console.log("updateTitle check", updatetitle);
  return (
    <Stack
      component="ul"
      spacing={0.5}
      sx={{
        listStyle: "none",
        m: 0,
        p: 0,
      }}
      {...other}
    >
      {subheader  && !isMinimized &&  (
        <Box
          component="li"
          sx={{
            color: "var(--nav-section-title-color)",
            fontSize: 12,
            fontWeight: 700,
            lineHeight: 1.66,
            mb: 1,
            ml: 1,
            textTransform: "uppercase",
          }}
        >
          {subheader}
        </Box>
      )}
      {renderItems({ items, pathname, updatetitle, isMinimized  })}
    </Stack>
  );
};

SideNavSection.propTypes = {
  items: PropTypes.array,
  pathname: PropTypes.string,
  subheader: PropTypes.string,
  isMinimized: PropTypes.bool.isRequired,
};
